
/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import { Product } from "../../types/products";

const GHOST_ICON_URL = 'https://raw.githubusercontent.com/ghost-protocol-labs/ghost-token-sui/refs/heads/main/assets/GHOST.svg';

export const MOCK_PRODUCTS: Product[] = [
  { 
    id: '1', 
    name: 'Ghost Hardware Vault', 
    description: 'Military-grade titanium hardware wallet with fingerprint enclave. Isolated from public network during key generation.', 
    price: 499.00, 
    category: 'Hardware', 
    image: 'https://cdn.builder.io/api/v1/image/assets%2F3b69a1d6a788481d933b37c04193077a%2F53a39e2e6621430089e51c8b3f1a9544', 
    stock: 24 
  },
  { 
    id: '2', 
    name: 'Sovereign Node License', 
    description: 'Annual license to run a GhostOS Relay node with priority fee sharing and enhanced ZK throughput.', 
    price: 1200.00, 
    category: 'Digital', 
    image: 'https://cdn.builder.io/api/v1/image/assets%2F3b69a1d6a788481d933b37c04193077a%2F096955a5078546a392e21e0655a6d36e' 
  },
  { 
    id: '3', 
    name: 'Ghost Merchant POS', 
    description: 'NFC & QR ready terminal for physical retail. Settles instantly to your vault via Solana Pay or Sui Move.', 
    price: 299.00, 
    category: 'Hardware', 
    image: 'https://cdn.builder.io/api/v1/image/assets%2F3b69a1d6a788481d933b37c04193077a%2Ff64121e9026343dba25f9b964d360980', 
    stock: 150 
  },
  { 
    id: '4', 
    name: 'Stealth Relay Credits', 
    description: '10,000 anonymized transaction credits for the GhostOS Relay. High entropy mixing for privacy-first businesses.', 
    price: 100.00, 
    category: 'Services', 
    image: 'https://cdn.builder.io/api/v1/image/assets%2F3b69a1d6a788481d933b37c04193077a%2F634024b89a8846c49fc72d55850980c5'
  },
  { 
    id: '5', 
    name: 'Titanium Membership Card', 
    description: 'Laser-etched physical card providing VIP access to Sovereign Lounges and 0% protocol fee swaps.', 
    price: 2500.00, 
    category: 'Hardware', 
    image: GHOST_ICON_URL,
    isNftGated: true,
    nftCollection: 'sovereign_elite_access'
  }
];
